import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'foundations-theming/utils';
import EPNavigationDropdown from 'editor-components/header/EPNavigationDropdown';
import EPNavigationItem from 'editor-components/header/EPNavigationItem';
import OutsideClickListener from 'editor-components/OutsideClickListener';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
// Using a styled ul instead of `List`, since `List` uses flex styling with
// `flex-wrap: wrap` on its ul element. Combined with our `flex-basis: 33%`
// style that we apply on the editor toolbar slot, this causes the top level
// navigation items to wrap to the next line at widths < 1800px.
const NavigationBarItemsWrapper = styled.ul.withConfig({
  displayName: "EPNavigationBar__NavigationBarItemsWrapper"
})(["display:flex;align-items:center;list-style:none;gap:", ";margin:", ";padding:", ";"], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['0']);
const EPNavigationBar = ({
  navigationGroups,
  onActiveItemChange,
  shouldClear
}) => {
  const [activeItem, setActiveItem] = useState('');
  const handleSetActiveItem = useCallback(id => {
    setActiveItem(id);
  }, []);
  const clearActiveItem = useCallback(() => {
    setActiveItem('');
  }, []);
  const handleOutsideClick = useCallback(e => {
    e.stopPropagation();
    clearActiveItem();
  }, [clearActiveItem]);
  useEffect(() => {
    if (shouldClear) {
      clearActiveItem();
    }
  }, [clearActiveItem, shouldClear]);
  useEffect(() => {
    if (onActiveItemChange) {
      onActiveItemChange(activeItem);
    }
  }, [activeItem, onActiveItemChange]);
  return /*#__PURE__*/_jsx(OutsideClickListener, {
    onOutsideClick: handleOutsideClick,
    children: /*#__PURE__*/_jsx(View, {
      as: "nav",
      blockSize: "1200",
      inlineSize: "100%",
      "data-onboarding": "ep-navigation-bar",
      "data-campaign-assistant-onboarding-tour": "tour-step-navigation",
      role: "navigation",
      children: /*#__PURE__*/_jsx(NavigationBarItemsWrapper, {
        children: navigationGroups.map(navigationGroup => {
          if (navigationGroup !== null && navigationGroup !== void 0 && navigationGroup.hideLink) {
            return null;
          }
          if (navigationGroup && 'children' in navigationGroup) {
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(EPNavigationDropdown, {
                activeItem: activeItem,
                clearActiveItem: clearActiveItem,
                setActiveItem: handleSetActiveItem,
                navGroup: navigationGroup
              })
            }, navigationGroup.id);
          } else if (navigationGroup) {
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(EPNavigationItem, {
                navItem: navigationGroup,
                isTopLevel: true
              })
            }, navigationGroup.id);
          } else {
            return null;
          }
        })
      })
    })
  });
};
EPNavigationBar.propTypes = {
  navigationGroups: PropTypes.array.isRequired,
  onActiveItemChange: PropTypes.func,
  shouldClear: PropTypes.bool
};
export default EPNavigationBar;